export default __webpack_public_path__ + "images/7c40193c3b83c2f8436edc52e767bbc7-halloweenhaunt.jpg";